<template>
  <div class="quiz-preview-wrapper">
  <div class="preview-header" />
  <div class="preview-body">
    <div class="preview-quiz-wrapper">
      <div class="tag-wrapper" v-if="getQuizTags(quiz)">
        <div class="tag" v-for="(value, index) in getQuizTags(quiz)" :key="index">
          {{ value }}
        </div>
      </div>
      <div class="content">
        {{ quiz.content }}
      </div>
      <div class="no-options-wrapper" v-if="isNoOptionsQuiz(quiz.options)">
        <div class="option">
          <img src="/static/images/ic-correct.svg" />
        </div>
        <div class="option">
          <img src="/static/images/ic-incorrect.svg" />
        </div>
      </div>
      <div class="options-wrapper" v-else>
        <div class="option" v-for="(option, index) in quiz.options" :key="index">
          {{ option.value }}
        </div>
      </div>
      
    </div>
  </div>
  <div class="preview-footer" />
  </div>
</template>

<script>
  import quiz from '../mixins/quiz';

  export default {
    name: 'quiz-preview',

    props: {
      quiz: {
        type: Object,
        default: {},
      },
    },

    mixins: [
      quiz,
    ],

  };
</script>

<style lang="scss" scoped>
  .quiz-preview-wrapper {
    background-image: linear-gradient(to bottom, #4823ae, #9751c7);
    position: relative;
    overflow: auto;
    margin: 0 10px 0 10px;

    .preview-header {
      height: 186px;
      width: 100%;
      background-image: url('/static/images/ic-area-top.png');
      background-position: center;
      background-repeat: no-repeat;
    }

    .preview-body {
      width: 100%;
      padding: 20px;

      .preview-quiz-wrapper {
        border-radius: 16px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
        background-image: linear-gradient(to bottom, #4823ae, #9751c7);

        .tag-wrapper {
          padding: 14px 14px 0 14px;

          .tag {
            margin: 0 8px 8px 0;
            font-size: 12px;
            border-radius: 16px;
            display: inline-block;
            border: solid 1px #30e3b8;
            color: #30e3b8;
            padding: 4px 8px 4px 8px;
          }
        }

        .content {
          color: #ffffff;
          font-size: 18px;
          padding: 14px 20px 0 20px;
        }

        .options-wrapper {
          padding: 20px;

          .option {
            width: 100%;
            height: 36px;
            border-radius: 18px;
            background-color: #ffffff;
            margin: 10px 0 10px 0px;
            text-align: center;
            font-size: 14px;
            color: #2b2b2b;
            padding: 8px;
          }
        }

        .no-options-wrapper {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          padding: 24px;

          .option {
            width: 65px;
            height: 65px;
            border-radius: 35px;
            background-color: #ffffff;
            padding: 18px;
          }
        }
      }
    }

    .preview-footer {
      height: 243px;
      background-image: url('/static/images/ic-area-bottom.png');
      background-position: center;
      background-repeat: no-repeat;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/my-quizzes/components/QuizPreview.vue